<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import * as echarts from 'echarts';
export default {
	data() {
		return {
			Zsyheight: 349,
			Duoheight: 0,
			DiZxtradio:'0',
			radio: '0',
			Piehuan: true,
			user:JSON.parse(localStorage.getItem("useropj")) ,
			//表格
			size: 'mini',
			headData: getdata().headData,
			pagination: getdata().pagination, //分页数据
			tableData: [{ tes1: '123', tes2: '123', tes3: '123123', tes4: '123', tes5: '123', tes6: '123', tes7: '123' }],
			tablekey: 0,
			//排序字段
			order: '',
			//排序顺序
			sort: '',
			tiemYear:new Date().getUTCFullYear(),
			tiemMonth:new Date().getUTCMonth()+1,
			titleList:{issuedInv:{},redInv:{},lineCreditVo:{}},
			dingList:{},
			DiZxtXY:{},
			DiZxt:{},
		};
	},
	mounted() {
		this.KSED()
		this.DKju()
		this.changeRight()
		this.changeDiZxt()
	},
	created() {
		this.ZhiShiYing()
	},
	methods: {
		// 最近待办
		DKju(){
			this.$https.fetchPost('/page/data/report/natural/getInvoiceRecentPending').then(res=>{
				if(res.data.code==200){
					this.dingList = res.data.data
				}else{
					this.$message.error(res.data.message)
				}
			})
		},
		//根据年月查询授信额度、蓝字红字发票信息
		KSED(){
			var formData = new FormData();
			formData.append('yearMonth',this.tiemYear+''+(this.tiemMonth<10?'0'+this.tiemMonth:this.tiemMonth))
			this.$https.fetchPost('/page/data/report/natural/getCurrentMonthInvoiceInfo',formData).then(res=>{
				if(res.data.code==200){
					this.titleList = res.data.data
					this.LanZiJiaSuiHeJi();
					this.HongZiJiaSuiHeJi();
				}else{
				
					// this.$message.error(res.data.message)
				}

			})
		},
		// 开票金额（含税）趋势分析
		changeRight(e){
			var formData = new FormData();
			formData.append('timeType',this.radio)
			this.$https.fetchPost('/page/data/report/natural/invoiceAmountTrendData',formData).then(res=>{
				if(res.data.code==200){
					this.DiZxtXY = res.data.data
					this.KpaiPiaoje();
				}else{
					this.$message.error(res.data.message)
				}
			})
		},
		// 开票数量趋势分析 (只包含红票和蓝票，作废发票不计算)
		changeDiZxt(e){
			var formData = new FormData();
			formData.append('timeType',this.DiZxtradio)
			this.$https.fetchPost('/page/data/report/natural/invoiceNumTrendData',formData).then(res=>{
				if(res.data.code==200){
					this.DiZxt = res.data.data
					this.KaiPiaoQus();
				}else{
					this.$message.error(res.data.message)
				}
			})
			
		},

		// 集团模式信息汇总
		summaryOfGroupInvoiceInformation(){
			let params = {
				limit:this.pagination.pageSize,
				page:this.pagination.pageNum,
				order:this.order,
				sort:this.sort,
				param:{
					yearMonth:this.tiemYear+''+(this.tiemMonth<10?'0'+this.tiemMonth:this.tiemMonth)
				}
			}
			this.$https.fetchPost('/page/data/report/natural/summaryOfGroupInvoiceInformation',params).then(res=>{
				if(res.data.code==200){
					this.tableData = res.data.data
					this.pagination.total = res.data.count
				}else{
					this.$message.error(res.data.message)
				}
			})
		},
		//切换
		ckQieHuan() {
			this.Piehuan = !this.Piehuan;
			if (this.Piehuan) {
				this.$nextTick(() => {
					this.KpaiPiaoje();
					this.KaiPiaoQus();
					this.LanZiJiaSuiHeJi();
					this.HongZiJiaSuiHeJi();
				});
			}else{
				this.summaryOfGroupInvoiceInformation()
			}
		},

		//自适应
		ZhiShiYing() {
			var clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
			if (clientHeight > 766) {
				this.Zsyheight = clientHeight - 535 + 'px';
				this.Duoheight = 0 + 'px';
			} else {
				this.Zsyheight = 349 + 'px';
				this.Duoheight = 776 - clientHeight + 'px';
			}
			this.$nextTick(() => {
				this.KpaiPiaoje();
				this.KaiPiaoQus();
				this.LanZiJiaSuiHeJi();
				this.HongZiJiaSuiHeJi();
			});
			window.addEventListener('resize', () => {
				this.$nextTick(() => {
					var clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
					if (clientHeight > 766) {
						this.Zsyheight = clientHeight - 535 + 'px';
						this.Duoheight = 0 + 'px';
					} else {
						this.Zsyheight = 349 + 'px';
						this.Duoheight = 776 - clientHeight + 'px';
					}
					this.KpaiPiaoje();
					this.KaiPiaoQus();
					this.LanZiJiaSuiHeJi();
					this.HongZiJiaSuiHeJi();
				});
			});
		},
		//蓝字价税合计
		HongZiJiaSuiHeJi() {
			let myChart = echarts.init(document.getElementById('HongZiJia'));
			var option;
			option = {
				series: [
					{
						type: 'pie',
						radius: ['40%', '70%'],
						itemStyle: {
							borderRadius: 0,
							borderColor: '#fff',
							borderWidth: 4
						},
						emphasis: false,
						label: {
							show: false
						},
						data: [
							{
								value: this.titleList.issuedInv.amountTotal,
								name: '蓝字发票不含税金额合计',
								itemStyle: {
									color: '#5A6FC0'
								}
							},
							{
								value: this.titleList.issuedInv.taxAmountTotal,
								name: '蓝字发票累计税额',
								itemStyle: {
									color: '#A0B1F5'
								}
							}
						]
					}
				]
			};
			myChart.setOption(option);
		},

		//红字价税合计
		LanZiJiaSuiHeJi() {
			let myChart = echarts.init(document.getElementById('LanZiJia'));
			var option;
			option = {
				series: [
					{
						emphasis: {
							scale: 0, // 禁止缩放
							itemStyle: {
								opacity: 1, // 去除透明度变化
								color: null // 去除颜色变化
							}
						},
						type: 'pie',
						radius: ['40%', '70%'],
						itemStyle: {
							borderRadius: 0,
							borderColor: '#fff',
							borderWidth: 4
						},
						label: {
							show: false
						},
						data: [
							{
								value: this.titleList.redInv.amountTotal,
								name: '红字发票不含税金额合计',
								itemStyle: {
									color: '#F29600'
								}
							},
							{
								value: this.titleList.redInv.taxAmountTotal,
								name: '红字发票累计税额',
								itemStyle: {
									color: '#FFCB76'
								}
							}
						]
					}
				]
			};
			myChart.setOption(option);
		},

		//开票金额(含税)趋势分析
		KpaiPiaoje() {
			let myChart = echarts.init(document.getElementById('number'));
			var option;
			option = {
				tooltip: {
					trigger: 'axis'
				},

				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				},
				legend: {
					data: ['蓝字发票', '红字发票']
				},
				xAxis: {
					type: 'category',
					boundaryGap: false,
					data:this.DiZxtXY.xaxisTitleList
				},
				yAxis: {
					type: 'value'
				},
				series: [
					{
						name: '蓝字发票',
						type: 'line',
						color: '#0065B1',
						data: this.DiZxtXY.dataAmountList
					},
					{
						name: '红字发票',
						type: 'line',
						color: '#E02020',
						data: this.DiZxtXY.redDataAmountList
					}
				]
			};
			myChart.setOption(option);
		}, //
		KaiPiaoQus() {
			var chartDom = document.getElementById('Kaipiaoqus');
			var myChart = echarts.init(chartDom);
			var option;
			option = {
				tooltip: {
					trigger: 'axis'
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				},
				legend: {
					data: ['蓝字发票', '红字发票'],
					        itemStyle: {
					                   color: function (params) {
					                       if (params.name === '蓝字发票') {
					                           return '#0065B1';
					                       } else if (params.name === '红字发票') {
					                           return '#E02020';
					                       }
					                   }
					               }
				},
				xAxis: {
					type: 'category',
					boundaryGap: false,
					data: this.DiZxt.xaxisTitleList
				},
				yAxis: {
					type: 'value'
				},
				series: [
					{
						smooth: true,
						name: '红字发票',
						data: this.DiZxt.redDataAmountList,
						type: 'line',
						lineStyle: {
							color: '#E02020'
						},
						color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
							{
								offset: 0,
								color: '#E02020'
							},{
								offset: 0.01,
								color: '#FFDFDF'
							},
							{
								offset: 1,
								color: '#FFFFFF'
							}
						]),
						areaStyle: {}
					},
					{
						smooth: true,
						name: '蓝字发票',
						data: this.DiZxt.dataAmountList,
						type: 'line',
						lineStyle: {
							color: '#0065B1'
						},
						color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
							{
								offset: 0,
								color: '#0065B1'
							},{
								offset: 0.01,
								color: '#ABDBFF'
							},
							{
								offset: 1,
								color: '#FBFBFB'
							}
						]),
						areaStyle: {}
					}
				]
			};
			myChart.setOption(option);
		},
		//行数
		sizechange(e) {
			this.pagination.pageSize = e;
			this.summaryOfGroupInvoiceInformation()
		}, //分页
		currentChange(e) {
			this.pagination.pageNum = e;
			this.summaryOfGroupInvoiceInformation()
		}, //表格体 排序
		sortchange(e) {
			if (e.order != null) {
				this.sort = e.order == 'ascending' ? 'ASC' : 'DESC';
				this.order = e.prop;
				this.summaryOfGroupInvoiceInformation()
			} else {
				this.sort = '';
				this.order = '';
			}
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
